import styled from 'styled-components';

export const StyledCommentsList = styled.div`
  ul {
    margin: 0;
    padding: 0;
    list-style: none;
  }

  .comments-list {
    max-height: 320px;
    padding-left: 15px;
    overflow: auto;
  }

  .comment {
    padding: 20px 0;
    text-align: right;
    color: ${props => props.theme.textTable};
    font-size: 13px;

    &:not(:last-child) {
      border-bottom: 1px solid ${props => props.theme.borderTable};
    }

    p {
      margin: 0;
    }

    &.is-my {
      color: ${props => props.theme.main};

      .name {
        color: ${props => props.theme.main};
      }
    }
  }

  .data {
    direction: ltr;
    span {
      margin-left: 10px;
    }
  }

  .name {
    font-size: 14px;
    color: ${props => props.theme.text};
    font-weight: bold;
  }
`;

export const StyledCommentsHistory = styled.section`
  margin-top: 60px;

  h3 {
    margin-bottom: 35px;
    font-family: var(--bllink-font-headers);
    text-align: right;
  }

  .nav-tabs {
    padding: 0;
    border-color: ${props => props.theme.borderDark};
    box-shadow: 7px 7px 25px rgba(206, 206, 206, 0.25);
    border-bottom: 1px solid ${props => props.theme.borderDark};
  }

  .nav-item {
    width: 50%;
  }

  .nav-link {
    width: 100%;
    padding: 15px 20px;
    border: none;
    border-top-left-radius: 25px;
    border-top-right-radius: 25px;
    background-color: #fff;
    font-size: 20px;
    color: ${props => props.theme.text};

    &.active {
      position: relative;
      font-weight: bold;
      color: ${props => props.theme.main};
      border-bottom: 1px solid ${props => props.theme.borderDark};
      &::after {
        position: absolute;
        content: '';
        bottom: -5px;
        right: 0;
        width: 100%;
        height: 5px;
        background: linear-gradient(90deg, #6895FF 10.74%, #8C5CFF 100.15%);
        box-shadow: 0 3px 10px rgba(89, 102, 137, 0.12);
        border-radius: 0 0 8px 8px;
      }
    }
  }

  .tab-content {
    padding: 0 30px 0 20px;
  }

  .comments-tabs {
    border: 1px solid ${props => props.theme.borderDark};
    box-shadow: 7px 7px 25px rgba(206, 206, 206, 0.25);
    border-radius: 25px;
    background-color: #fff;
  }
`;

export const StyledAddComment = styled.div`
  padding: 30px 0;

  &.with-border {
    border-top: 1px solid ${props => props.theme.borderTable};
  }
  .form-control-group {
    position: relative;
  }
  .form-control {
    height: auto;
    padding: 8px 15px;
    color: ${props => props.theme.text};
    font-size: 15px;
    line-height: 23px;
    background: rgba(233, 233, 253, 0.54);
    border: 1px solid rgba(135, 100, 255, 0.22);
    border-radius: 8px;
  }
  
  .send {
    position: absolute;
    left: ${({ ltr }) => ltr ? '' : '15px'};
    right: ${({ ltr }) => ltr ? '15px' : ''};
    top: 50%;
    transform: translateY(-50%);
    cursor: pointer;
  }
`;

export const StyledCommentsModalContent = styled.div`
  .form-group {
    .label {
      margin: 0 15px 8px 0;
      font-weight: bold;
    }
  }
  .add-comment {
    padding-bottom: 0;
  }
  .comments {
    padding: 15px 20px 20px;
    border: 1px solid ${props => props.theme.borderDark};
    box-shadow: 7px 7px 25px rgba(206, 206, 206, 0.25);
    border-radius: 25px;
    &-title {
      padding-bottom: 15px;
      border-bottom: 1px solid ${props => props.theme.borderTable};
      text-align: center;
      font-size: 15px;
      color: ${props => props.theme.main};
      font-weight: bold;
    }
  }
`;
